import './assets/main.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import { createRouter, setupRouterGuards } from './router'
import { useThemeStore } from './stores/useThemeStore'
import { hydrateSecureStorage, SECURE_AUTH_KEYS } from './lib/secureStorage'

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Decrypt auth data into memory before anything (router guards, authStore's
// initial state) tries to read it — see src/lib/secureStorage.ts.
void hydrateSecureStorage(SECURE_AUTH_KEYS).then(() => {
  const router = createRouter()
  setupRouterGuards(router, pinia)

  const app = createApp(App)

  app.use(pinia)
  app.use(router)

  router.isReady().then(() => {
    useThemeStore().init()
    app.mount('#app')
  })
})
